import { subscriptionsApi } from '../api/client';
import { ONBOARDING_PATH } from './onboarding';

export interface PostAuthUser {
  isAdmin?: boolean;
  emailVerified?: boolean;
}

/**
 * Resolves where to send a user immediately after login or when visiting a public route while logged in.
 * Fails closed to onboarding when the billing status API is unreachable.
 */
export async function resolvePostAuthPath(user: PostAuthUser): Promise<string> {
  if (!user.isAdmin && user.emailVerified === false) {
    return '/verify-email';
  }

  if (user.isAdmin) {
    return '/dashboard';
  }

  try {
    const status = await subscriptionsApi.getOnboardingStatus();
    return status.requiresPaymentSetup ? ONBOARDING_PATH : '/dashboard';
  } catch {
    return ONBOARDING_PATH;
  }
}
